import { ScrollReveal } from '@podus/ui';
import { PRODUCT_URLS } from '@podus/utils';

const features = [
    {
        title: 'Smart Case Detection',
        description:
            'Podus AI doesn\u2019t just answer questions\u2014it understands context. As you chat, it identifies when your issue may require formal dispute resolution and proactively recommends the next best step, so you\u2019re never left guessing.',
    },
    {
        title: 'Court-Connected Resolution',
        description:
            'Podus Multidoor links you to Nigeria\u2019s Multi-Door Courthouse system, giving you access to trusted pathways like mediation, arbitration, and conciliation.',
    },
    {
        title: 'Seamless Case Filing',
        description:
            'When it\u2019s time to act, you can initiate a case directly within your conversation. No switching platforms, no complex processes\u2014just a guided, step-by-step experience that gets your case filed quickly and correctly.',
    },
    {
        title: 'Real-Time Updates',
        description:
            'Stay informed without the stress of follow-ups. Track your case progress, receive timely updates, and know exactly what\u2019s happening at every stage\u2014from filing to final resolution.',
    },
];

export default function MultidoorSection() {
    return (
        <section className="px-4 py-8 lg:px-16 lg:py-20 xl:px-20">
            <div className="mx-auto max-w-[1920px]">
                <div className="flex flex-col gap-5 lg:flex-row">
                    {/* Left — dark card */}
                    <ScrollReveal variant="fade-right" delay={0} distance={30} className="lg:w-[32%]">
                        <div className="flex h-full flex-col justify-between rounded-2xl bg-[#1a1a1a] bg-[url('/assets/slate-texture-background.png')] bg-cover bg-center p-8 lg:rounded-3xl lg:p-10">
                            <div>
                                <div className="mb-6">
                                    <div className="flex items-center gap-2">
                                        <img src="/logos/podus-multidoor.svg" alt="" className="h-10 w-auto sm:h-12" />
                                        <span className="text-[clamp(2rem,5vw,3rem)] font-bold leading-none text-[#999]">
                                            Podus
                                        </span>
                                    </div>
                                    <p className="text-[clamp(2.2rem,6vw,3.5rem)] font-bold leading-[1.1] text-white">
                                        Multidoor
                                    </p>
                                </div>
                                <p className="mt-6 text-[14px] leading-[1.8] text-[#ffffff] sm:text-[15px]">
                                    Podus Multidoor connects you directly to Nigeria&rsquo;s Multi-Door Courthouse
                                    system, allowing you to seamlessly open and manage cases through mediation,
                                    arbitration, conciliation, and other court-recognized dispute resolution methods.
                                </p>
                            </div>
                            <a
                                href={PRODUCT_URLS.podusmultidoor}
                                className="mt-8 flex items-center justify-center rounded-full bg-white px-8 py-4 text-[15px] font-bold text-[#1a1a1a] transition-transform hover:scale-[1.02] active:scale-[0.98]"
                            >
                                Get Started
                            </a>
                        </div>
                    </ScrollReveal>

                    {/* Right — feature grid */}
                    <div className="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                        {features.map((f, i) => (
                            <ScrollReveal key={f.title} variant="fade-up" delay={100 + i * 100} distance={20}>
                                <div className="flex h-full flex-col rounded-2xl bg-[#f5f5f5] p-7 lg:rounded-3xl lg:p-8">
                                    <h3 className="text-[clamp(1.3rem,3vw,1.75rem)] font-bold leading-[1.15] tracking-tight text-[#8D8D8D]">
                                        {f.title}
                                    </h3>
                                    <p className="mt-3 text-[13px] leading-[2] text-[#4E4D4D] sm:text-[14px]">
                                        {f.description}
                                    </p>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
